import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/services/api';

interface GeneratePermissionResponse {
  message: string;
}

export function useGeneratePermission() {
  const queryClient = useQueryClient();

  return useMutation<GeneratePermissionResponse, Error, number>({
    mutationFn: async () => {
      const response = await api.put(`/usuario/geral/gerar/permissao`);
      return response.data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: ['usuario/geral',]
      });
    },
  });
}